import Anime from "../components/Anime";
import Products from "../components/Products";
import Highlight from "../components/Highlight";
import AboutImg from "../images/about.jpeg";
import { Link } from "react-router-dom";

const Home = () => (
  <>
    <Highlight />

    <div className="p-24">
      <Anime />
    </div>

    <div className="flex bg-neutral-100">
      <img src={AboutImg} alt="" className="w-1/2 h-96 object-cover" />
      <div className="p-8">
        <h2 class="my-12 text-5xl font-bold tracking-tight leading-tight font-roboto">
          O melhor plano <br />
          <span class="text-gray-400">para desenvolver 1 ideia</span>
        </h2>
        <Link
          class="inline-block px-7 py-3 bg-gray-400 text-white font-medium text-sm leading-snug uppercase rounded shadow-md hover:bg-gray-800 hover:shadow-lg focus:bg-gray-800 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg transition duration-150 ease-in-out mb-2 md:mr-2"
          to="/contacts"
          onClick={() => {
            window.scroll({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          }}
        >
          Contacte-nos
        </Link>
        <Link
          class="inline-block px-7 py-3 bg-transparent text-gray-400 font-medium text-sm leading-snug uppercase rounded hover:text-gray-800 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none focus:ring-0 active:bg-gray-200 transition duration-150 ease-in-out mb-2"
          to="/about"
          onClick={() => {
            window.scroll({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          }}
        >
          Saiba mais
        </Link>
      </div>
    </div>

    <Products />
  </>
);

export default Home;
